import { mobilePageTitleAtom } from 'config/store'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { Button, Container, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import hidePassIcon from 'assets/images/login-hidepass.svg'
import showPassIcon from 'assets/images/login-showpass.svg'
import passIcon from 'assets/images/login-lock.svg'
import { showSnackbar } from 'store/actions'
import { useChangePass, useRequestOTP } from 'dataLayer/user'
import { useDispatch } from 'react-redux'
import { getUserinfo } from 'utils/localStorage'
import ConfirmModal from 'components/Modal/ConfirmModal'
import OTPConfirmModal from 'components/Modal/OTPConfirmModal'

function ChangePassMobile({ title }) {
	const { t } = useTranslation()

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const dispatch = useDispatch()
	const [infoData, setInfoData] = useState({
		newPass: '',
		confirmPass: '',
	})
	const user = getUserinfo()
	function handleInfoChange(e) {
		const newInfoData = { ...infoData }
		newInfoData[e.target.id] = e.target.value
		setInfoData(newInfoData)
	}

	const [isPass, setIsPass] = useState(true)
	function handleNewPass() {
		setIsPass(prev => !prev)
	}
	const [isConfirmPass, setIsConfirmPass] = useState(true)
	function handleConfirmPass() {
		setIsConfirmPass(prev => !prev)
	}
	const closeConfirmModal = () => {
		setModalConfirm(false)
	}
	const onShowOTP = () => {
		setModalConfirm(false)
		setModalShowOTP(true)
	}
	const { mutate, isLoading } = useRequestOTP(onShowOTP)
	const { mutate: changePass, data: dataChangePass } = useChangePass(
		result => {
			dispatch(showSnackbar(true, t('modal.success'), 'success'))
		},
		result => {
			dispatch(showSnackbar(true, result?.message || t('modal.error'), 'error'))
		},
	)
	const [modalConfirm, setModalConfirm] = useState(false)
	const [modalShowOTP, setModalShowOTP] = useState(false)
	const showOTP = () => {
		if (infoData.newPass === '' || infoData.confirmPass === '') {
			dispatch(showSnackbar(true, t('modal.change_pass_error'), 'error'))
		} else {
			setModalConfirm(true)
		}
	}
	const openOTPAndCloseConfirmModal = () => {
		mutate({
			msisdn: user.msisdn,
		})
	}
	const handleChangePass = data => {
		if (data === null || data === '') {
			dispatch(showSnackbar(true, t('modal.shop.error_null_OTP'), 'error'))
		} else {
			changePass({
				otp: data,
				password: infoData.newPass,
				re_password: infoData.confirmPass,
			})
		}
	}
	const closeOTPModal = () => {
		setModalShowOTP(false)
	}
	return (
		<>
			<Container fluid className="userinfo-mobile-container">
				<Row className="profilepage-content__body mobile my-3">
					<Form className="baseinput-container">
						<Form.Group className="mb-5 base-input personal-info">
							<Form.Label>{t('profile.change_pass.new')}</Form.Label>
							<img src={passIcon} alt="Type your new password" />
							<Form.Control
								type={isPass ? 'password' : 'text'}
								value={infoData.newPass}
								onChange={handleInfoChange}
								id="newPass"
								placeholder={t('profile.change_pass.new')}
								style={{ paddingLeft: 45 }}
							/>
							<img
								src={isPass ? hidePassIcon : showPassIcon}
								onClick={handleNewPass}
								alt="Show password"
							/>
						</Form.Group>
						<Form.Group className="mb-3 base-input personal-info">
							<Form.Label>{t('profile.change_pass.enter_new')}</Form.Label>
							<img src={passIcon} alt="Confirm your new password" />
							<Form.Control
								type={isConfirmPass ? 'password' : 'text'}
								value={infoData.confirmPass}
								onChange={handleInfoChange}
								id="confirmPass"
								placeholder={t('profile.change_pass.enter_new')}
								style={{ paddingLeft: 45 }}
							/>
							<img
								src={isConfirmPass ? hidePassIcon : showPassIcon}
								onClick={handleConfirmPass}
								alt="Show password"
							/>
						</Form.Group>
					</Form>
					<Button
						className="profile-confirm mobile"
						onClick={showOTP}
						disabled={isLoading}
					>
						{t('confirm')}
					</Button>
				</Row>
				<ConfirmModal
					show={modalConfirm}
					onHide={closeConfirmModal}
					title={t('modal.change_pass')}
					onShowOTP={openOTPAndCloseConfirmModal}
				/>
				<OTPConfirmModal
					isChangePass={true}
					show={modalShowOTP}
					onHide={closeOTPModal}
					handleResendPassOTP={openOTPAndCloseConfirmModal}
					handleChangePass={handleChangePass}
					phone={user.msisdn}
				/>
			</Container>
		</>
	)
}

export default ChangePassMobile
